import { render, staticRenderFns } from "./sharelist.vue?vue&type=template&id=b4b47532&scoped=true&"
import script from "./sharelist.vue?vue&type=script&lang=js&"
export * from "./sharelist.vue?vue&type=script&lang=js&"
import style0 from "./sharelist.vue?vue&type=style&index=0&id=b4b47532&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4b47532",
  null
  
)

export default component.exports